__turbopack_context__.v({
  "badgeLogo": "styles-module__GWsO_G__badgeLogo",
  "ctaButton": "styles-module__GWsO_G__ctaButton",
  "ctaLink": "styles-module__GWsO_G__ctaLink",
});
